import * as pdfjsLib from 'pdfjs-dist';
import * as pdfWorkerModule from 'pdfjs-dist/build/pdf.worker.min.mjs';

type PdfjsWorkerGlobal = typeof globalThis & {
  pdfjsWorker?: typeof pdfWorkerModule;
};

let workerConfigured = false;

function configurePdfjsWorker(): void {
  if (workerConfigured) return;
  // pdf.js fake-worker 回退路径会读取该全局变量，避免动态 import worker 静态资源。
  (globalThis as PdfjsWorkerGlobal).pdfjsWorker = pdfWorkerModule;
  workerConfigured = true;
}

configurePdfjsWorker();

/** 确保 pdf.js worker 已配置（模块导入时已 eager 初始化，此处为幂等保障）。 */
export function ensurePdfjsWorker(): void {
  configurePdfjsWorker();
}

export { pdfjsLib };
